/**
 * Implements Mapbox API to add custom controls along Mapbox out of the
 * controls. This control will use the Mapbox container DIV element and
 * its immediate parent to create to resize the map and create the gray
 * background.
 */
export default class MapFullscreenControl {
    constructor() {
        this._onClickFullscreenView = this._onClickFullscreenView.bind(this);
    }

    onAdd(map) {
        this._map = map;
        this._container = document.createElement('div');
        this._container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';

        this._MapFullscreenButton = document.createElement('button');
        this._MapFullscreenButton.className = 'mapboxgl-ctrl-icon mapboxgl-ctrl-fullscreen';
        this._MapFullscreenButton.setAttribute('aria-label', 'Toggle fullscreen');
        this._MapFullscreenButton.type = 'button';
        this._MapFullscreenButton.addEventListener('click', this._onClickFullscreenView);
        this._container.appendChild(this._MapFullscreenButton);

        return this._container;
    }

    _onClickFullscreenView() {
        this._MapFullscreenButton.classList.toggle('mapboxgl-ctrl-fullscreen');
        this._MapFullscreenButton.classList.toggle('mapboxgl-ctrl-shrink');

        const mapContainer = this._map.getContainer();
        mapContainer.classList.toggle('map-modal');

        const backgroundContainer = mapContainer.parentElement;
        backgroundContainer.classList.toggle('map-modal-background');

        this._map.resize();
    }

    onRemove() {
        this._container.parentNode.removeChild(this._container);
        this._map = undefined;
    }
}
